module.exports = __webpack_public_path__ + "img/kv2.f07519bf.png";